// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__384dJ","header":"ClearentDisclaimer_header__Xx1ch","inner":"ClearentDisclaimer_inner__1m9qp"};